import React, { Component } from "react";

class Design8 extends Component {
  render() {
    return (
      <section className="evive-subfooter">
        <div className="container">
          <div className="evive-subfooter-row">
            <p>&copy; {new Date()?.getFullYear()} {process.env.REACT_APP_NAME || "EviveSoma"}. Tous droits réservés.</p>
            <p>Conçu par <a href="https://evivedigital.net" rel="noopener noreferrer" target="_blank">EviveDigital</a></p>
          </div>
        </div>
      </section>
    );
  }
}

export default Design8;
